import { Col, Space } from 'antd';
import React from 'react';

import { useTranslation } from 'react-i18next';
import { GREY_WHITE, GRID_MD, GRID_SM, RowExt } from '../../../styles';
import { BLUE, BLUE_MEDIUM, RED } from '../../../styles/colors';
import useWindowSize from '../../../utils/hooks/useWindowSize';
import SloganFooterSM from './SloganFooter/SloganFooterSM';
import SloganMenuButton from './SloganFooter/SloganMenuButton';
import SloganSocialMedia from './SloganFooter/SloganSocialMedia';
import SloganLangButton from './SloganFooter/SloganLangButton';

const SloganFooter = () => {
  const { width } = useWindowSize();
  const { t } = useTranslation();
  return (
    <>
      <RowExt
        align="bottom"
        bgColor={GREY_WHITE}
        paddingBottom="md"
        fullWidth
        paddingTop={width <= GRID_SM ? 24 : 24}
      >
        <Col
          sm={{
            offset: 2, span: 20
          }}
          xs={{
            offset: 2, span: 20
          }}
        >
          <Space>
            <SloganSocialMedia />
            <SloganMenuButton
              pathname="/subscribe"
              text="Road map"
              borderColor={RED}
            />
            {width < GRID_MD ? (
              <SloganMenuButton
                pathname="/guides"
                text="Video"
                borderColor={BLUE}
              />
            ) : null}
            <SloganMenuButton
              pathname="/developer"
              text="API"
              borderColor={BLUE_MEDIUM}
            />
            <SloganLangButton
              borderColor={BLUE}
            />
          </Space>
        </Col>
      </RowExt>
      <SloganFooterSM />
    </>
  );
};

export default SloganFooter;

